<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout === 'empty') {
  <empty-layout />
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with horizontal navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Centered -->
@if (layout === 'centered') {
  <centered-layout />
}

<!-- Enterprise -->
@if (layout === 'enterprise') {
  <enterprise-layout />
}

<!-- Material -->
@if (layout === 'material') {
  <material-layout />
}

<!-- Modern -->
@if (layout === 'modern') {
  <modern-layout />
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with vertical navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Classic -->
@if (layout === 'classic') {
  <classic-layout />
}

<!-- Classy -->
@if (layout === 'classy') {
  <classy-layout />
}

<!-- Compact -->
@if (layout === 'compact') {
  <compact-layout />
}

<!-- Dense -->
@if (layout === 'dense') {
  <dense-layout />
}

<!-- Futuristic -->
@if (layout === 'futuristic') {
  <futuristic-layout />
}

<!-- Thin -->
@if (layout === 'thin') {
  <thin-layout />
}
